import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { adminLogin, setAdminToken, getAdminToken } from '../lib/api';
import logoFull from '../assets/logo_full.webp';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (getAdminToken()) navigate('/admin'); }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { access_token } = await adminLogin(email.trim(), password);
      setAdminToken(access_token);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
      setLoading(false);
    }
  };

  const inputCls = 'field-luxe w-full bg-[#141311] border border-[#c6a15b]/30 px-4 py-3.5 font-body text-sm text-[#f7f3ec] placeholder:text-[#7a7365]';

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[#0b0b0b] px-4 py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src={logoFull} alt="Nikki's Next Level" className="w-44 mx-auto mb-6 object-contain" />
          <p className="overline text-gold-gradient mb-2">Admin Portal</p>
          <h1 className="font-display text-4xl text-[#f7f3ec]">Sign In</h1>
        </div>
        <form onSubmit={submit} className="bg-[#141311] border border-[#c6a15b]/20 p-8 space-y-5">
          <div>
            <label className="overline text-[0.6rem] text-[#9c9587] block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@nikkisnextlevel.com" className={inputCls} data-testid="admin-email-input" />
          </div>
          <div>
            <label className="overline text-[0.6rem] text-[#9c9587] block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" className={inputCls} data-testid="admin-password-input" />
          </div>
          {error && <p className="font-body text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading}
            className="btn-gold w-full py-4 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-btn">
            <span className="flex items-center gap-2">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />} {loading ? 'Signing in…' : 'Sign In'}
            </span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
